import { useEffect, useRef } from "react";
import { useU2000WebSocketContext } from "../u2000Core/context/websocket/U2000WebSocketContext";
import {
  isNotificationMessage,
  U3121_PROJECT_OPENING_FORM_PDF_EXPORT_JOB_TYPE,
} from "../u2000Core/types/U2000WebSocketMessages";

/**
 * Écoute les notifications WebSocket "notification:new" pour le job U3121 export PDF formulaire ouverture.
 * Lorsque metadata.jobType === U3121_PROJECT_OPENING_FORM_PDF_EXPORT et metadata.projectId
 * correspond au projet courant, appelle onProjectRefreshed pour rafraîchir le projet.
 */
export function useU3121ProjectOpeningFormPdfNotification(
  projectId: string | undefined,
  onProjectRefreshed: (projectId: string) => void
) {
  const { on, off } = useU2000WebSocketContext();
  const onRefreshedRef = useRef(onProjectRefreshed);
  onRefreshedRef.current = onProjectRefreshed;

  useEffect(() => {
    if (!projectId) return;

    const handleNotification = (message: unknown) => {
      if (!isNotificationMessage(message)) return;

      const metadata = message.metadata as Record<string, unknown> | undefined;
      const jobType = metadata?.jobType as string | undefined;
      const projectIdFromMsg = metadata?.projectId as string | undefined;

      if (
        jobType === U3121_PROJECT_OPENING_FORM_PDF_EXPORT_JOB_TYPE &&
        projectIdFromMsg === projectId
      ) {
        if (import.meta.env.DEV) {
          console.log("[U3121 Project Opening Form PDF] Notification reçue, refetch project:", projectId);
        }
        onRefreshedRef.current(projectId);
      }
    };

    on("notification:new", handleNotification);
    return () => off("notification:new", handleNotification);
  }, [projectId, on, off]);
}
